import manropeRegular from '../../assets/fonts/manrope-regular.ttf';
import manropeSemiBold from '../../assets/fonts/manrope-semibold.ttf';
import manropeBold from '../../assets/fonts/manrope-bold.ttf';
import { Font } from '@react-pdf/renderer';
import { generalStyles } from './generalStyles';

Font.register({
  family: 'Manrope',
  fonts: [
    {
      src: manropeRegular,
      fontWeight: 'normal',
    },
    {
      src: manropeSemiBold,
      fontWeight: 'semibold',
    },
    {
      src: manropeBold,
      fontWeight: 'bold',
    },
  ],
});

// Disable word hyphenation
Font.registerHyphenationCallback((word) => ['', word, '']);

// Merge styles into one object for easier usage
const styles = {
  ...generalStyles,
};

export default styles;
// Create styles
// export const styles = StyleSheet.create({
// -------------------- GENERAL STYLING -------------------- //
//   document: { fontFamily: 'Manrope' },
// -------------------- MAIN PAGE -------------------- //
//   mainPage: {
//     flexDirection: 'column',
//     fontSize: 10,
//     fontFamily: 'Manrope',
//     fontWeight: 'extrabold',
//   },
//   // Two columns container for first page A4
//   columnsContainer: {
//     flexDirection: 'row',
//     flex: 1,
//   },
//   leftColumn: {
//     width: '40%',
//     padding: 20,
//     backgroundColor: '#F2F2F2',
//   },
//   rightColumn: {
//     padding: 20,
//     width: '60%',
//   },
//   // Header "Validation Report"
//   header: {
//     fontSize: 18,
//     marginBottom: 10,
//     fontWeight: 'bold',
//   },
//   //PAGE 1 RIGHT SIDE START
//   rangeContainer: {
//     padding: 10,
//   },
//   label: {
//     fontSize: 16,
//     marginBottom: 5,
//   },
//   rangeBar: {
//     position: 'relative',
//     height: 10,
//     backgroundColor: '#e0e0e0',
//     width: '100%',
//     // borderRadius: 5,
//     overflow: 'hidden',
//     border: '1px',
//   },
//   matchSegment: {
//     position: 'absolute',
//     height: '100%',
//     backgroundColor: '#4caf50', // Matched segment color
//     borderRightColor: 'grey', // Right border color
//     borderRightWidth: 1, // Right border width
//   },
//   //PAGE 1 RIGHT SIDE END
//   reportTxt: { color: '#A8A8AA' },
//   // Left column section "wrappers"
//   section: {
//     marginBottom: 20,
//   },
//   subheader: {
//     fontSize: 14,
//     marginBottom: 6,
//     fontWeight: 'bold',
//     color: '#333',
//   },
//   text: {
//     marginBottom: 4,
//     lineHeight: 1.5,
//     flexWrap: 'wrap',
//     borderWidth: 1,
//     borderColor: '#ccc',
//   },
//   // Table for File Data Hash Range
//   itemContainer: {
//     width: '100%',
//     borderWidth: 1,
//     borderColor: '#ccc',
//   },
//   itemRow: {
//     flexDirection: 'row',
//     alignItems: 'center',
//     marginBottom: 5,
//     borderWidth: 1,
//     borderColor: '#ccc',
//   },
//   itemHeader: {
//     fontWeight: 'bold',
//     fontSize: 10,
//     width: '40%',
//   },
//   itemCell: {
//     padding: 5,
//     fontSize: 10,
//     width: '60%',
//     flexWrap: 'wrap',
//   },
//   // -------------------- SUMMARY & DETAILS PAGE -------------------- //
//   tableRow: {
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     paddingVertical: 5,
//   },
//   tableHeader: {
//     backgroundColor: '#ddd',
//     paddingVertical: 5,
//   },
//   // -------------------- SUMMARY PAGE -------------------- //
//   summaryPage: {
//     padding: 20,
//     fontSize: 10,
//   },
//   table: {
//     // display: 'flex',
//     width: '100%',
//     marginBottom: 20,
//     border: '1px solid #ccc',
//   },
//   tableCellAlternate: {
//     backgroundColor: '#f2f2f2', // Light grey for alternate rows
//   },
//   tableCell: {
//     // border: '1px solid #ccc',
//     textAlign: 'center',
//   },
//   tableCellName: {
//     textAlign: 'center',
//     fontWeight: 'bold',
//     width: '100%',
//   },
//   tableCellRange: {
//     width: '8%',
//   },
//   tableCellHash: {
//     width: '73%',
//   },
//   tableCellMatch: {
//     width: '11%',
//   },
//   sectionTitle: {
//     fontSize: 12,
//     marginBottom: 10,
//     fontWeight: 'bold',
//     textAlign: 'center',
//   },
//   // Block with Matching Hash
//   bTableCell: {
//     width: '50%',
//     textAlign: 'center',
//   },
//   referenceLink: {
//     marginLeft: 'auto',
//     textDecoration: 'none',
//     fontSize: 8,
//   },
// -------------------- DETAILS PAGE -------------------- //
//   detailsPage: {
//     padding: 20,
//     fontSize: 14,
//   },
//   dHeader: {
//     marginBottom: 6,
//     textAlign: 'center',
//     fontSize: 14,
//     fontWeight: 'bold',
//     color: '#333',
//   },
//   dSubheader: {
//     fontSize: 12,
//     fontWeight: 'bold',
//     color: '#333',
//     padding: 5,
//   },
//   // File Data Hash Range
//   dRangeHeader: {
//     backgroundColor: '#ddd',
//   },
//   dRangeContainer: {
//     marginBottom: 20,
//     // borderTop: '1px solid #ccc',
//     borderRight: '1px solid #ccc',
//     backgroundColor: '#f9f9f9',
//   },
//   dTableHeader: {
//     fontWeight: 'bold',
//     fontSize: 10,
//     color: '#555',
//   },
//   dTableRow: {
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     paddingVertical: 5,
//     paddingHorizontal: 5,
//     borderBottom: '1px solid #ccc',
//     backgroundColor: '#F2F2F2',
//   },
//   dTableCell: {
//     fontSize: 10,
//     color: '#333',
//   },
//   dRangeBox: {
//     marginBottom: 10,
//     pageBreakBefore: 'auto', // Avoid breaking before the block
//     pageBreakAfter: 'always', // Force break after a block to avoid splitting
//   },
//   dBlockHeader: {
//     backgroundColor: '#ddd',
//   },
//   dBlockTable: {
//     width: '100%',
//     // marginBottom: 5,
//   },
// });
